import { SvgIconProps } from '@/types/helpers'

export default function RoundClose(props: SvgIconProps) {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g filter="url(#filter0_b_976_127333)">
        <circle cx="28" cy="28" r="28" fill="#D9D9D9" fillOpacity="0.2" />
      </g>
      <path
        d="M18.9266 16.5021C18.2571 15.8326 17.1717 15.8326 16.5023 16.5021C15.8328 17.1716 15.8328 18.257 16.5023 18.9265L25.5756 27.9999L16.5021 37.0735C15.8326 37.743 15.8326 38.8284 16.5021 39.4979C17.1716 40.1674 18.257 40.1674 18.9264 39.4979L28 30.4243L37.0736 39.4979C37.743 40.1674 38.8284 40.1674 39.4979 39.4979C40.1674 38.8284 40.1674 37.743 39.4979 37.0735L30.4243 27.9999L39.4977 18.9265C40.1672 18.257 40.1672 17.1716 39.4977 16.5021C38.8283 15.8326 37.7428 15.8326 37.0734 16.5021L28 25.5756L18.9266 16.5021Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_b_976_127333"
          x="-20"
          y="-20"
          width="96"
          height="96"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="10" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_976_127333"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_976_127333"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
